"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.inter = void 0;
const utils_1 = require("../utils");
const base_1 = require("./base");
// Inter has custom letter spacing in Opal
exports.inter = (0, utils_1.mergeTypographyStyles)(base_1.opalBase, {
    title5xl: {
        letterSpacing: -0.25,
    },
    title4xl: {
        letterSpacing: -0.175,
    },
    title3xl: {
        letterSpacing: -0.125,
    },
    title2xl: {
        letterSpacing: -0.075,
    },
    titleXl: {
        letterSpacing: -0.05,
    },
    titleLg: {
        letterSpacing: -0.03125,
    },
    titleMd: {
        letterSpacing: -0.01875,
    },
    titleSm: {
        letterSpacing: -0.00625,
    },
    titleXs: {
        letterSpacing: -0.00625,
    },
    bodyLg: {
        letterSpacing: -0.03125,
    },
    bodyMd: {
        letterSpacing: -0.0125,
    },
    bodySm: {
        letterSpacing: -0.00625,
    },
    bodyXs: {
        letterSpacing: -0.00625,
    },
    buttonLg: {
        letterSpacing: -0.01875,
    },
    buttonMd: {
        letterSpacing: -0.0125,
    },
    buttonSm: {
        letterSpacing: -0.00625,
    },
});
//# sourceMappingURL=inter.js.map